export enum ChartType {
  total = "Total",
  gender = "Kön",
  bornYear = "Födelseår",
  bornDecade = "Årtionde",
  party = "Parti",
  county = "Län"
}
